export default "__VITE_ASSET__CJeQM__g__"